import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { EditorService } from '../../../../../bookeditoption/editor.service';
@Component({
  selector: 'app-textimage',
  templateUrl: './textimage.component.html',
  styleUrls: ['./textimage.component.css']
})
export class TextimageComponent implements OnInit {
  @Input() data: any;
  bookObj
  showHidehgt = true;
  textImageData;
  imageHeightVal = undefined;
  imageWidthVal = undefined;
  selectedImageUrl;
  updatedComment;
  constructor(private editorService: EditorService, private ele: ElementRef) { }
  isTextImageSelector = true;
  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "Image") {
      this.textImageData = cardData;
      this.initializeData(cardData);
    }
  }
  initializeData(data) {
    if (data.height) {
      this.imageHeightVal = data.height;
    }
    if (data.width) {
      this.imageWidthVal = data.width;
    }
    if (data.comment) {
      setTimeout(() => {
        this.ele.nativeElement.querySelector('.textCommentCon').innerHTML = data.comment;
      }, 10);
      this.showHidehgt = true;
      //  this.textComment = data.comment;
    }
  }
  onChangeGalleryimage(img) {
    this.selectedImageUrl = img.url;
    var image = new Image();
    image.src = img.url;
    var that = this;
    this.showHidehgt = true;
    image.onload = function () {
      that.imageWidthVal = 100;
      that.imageHeightVal = 100;
    }
    this.configTextImage();
    this.showHidehgt = true;
  }
  // onMediaElementSelect
  showHideWdtHgt(state) {
    if (state == "false") {
      this.showHidehgt = false;
    } else {
      this.showHidehgt = true;
    }
  }

  //For updating the image width
  changeImageWidth(evt) {
    if (evt.keyCode == "13") {
      this.changeTextImageWidth();
    }
  }
  changeTextImageWidth() {
    this.configTextImage();
  }

  //For updating the image Height
  changeImageHeight(evt) {
    if (evt.keyCode == 13) {
      this.changeTextImageHeight();
    }
  }
  changeTextImageHeight() {
    this.configTextImage();
  }
  updateImageComment(comment) {
    this.updatedComment = comment.innerHTML;
    this.configTextImage();
  }
  configTextImage() {
    let layer = this.editorService.getIframeReference();
    let obj: any = {
      'url': this.selectedImageUrl,
      'comment': this.updatedComment,
      'width': this.imageWidthVal,
      'height': this.imageHeightVal
    }
    layer.updateTextMediaProperties(obj);
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/text/media/textimage/textimage.component.ts